import { Component,Input } from '@angular/core';

@Component({
  selector: 'app-svg-palette',
  templateUrl: './svg-palette.component.html',
  styleUrls: ['./svg-palette.component.scss']
})
export class SvgPaletteComponent {
  @Input() icon:string=""
}
